import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, UsersIcon } from 'lucide-react';
import { Heading } from './Heading';
import { Reveal } from './Reveal';
import { CountUp } from './CountUp';
import { stats } from '../data/about';
const statStyles = [{
  card: 'bg-accent-gold',
  icon: 'bg-white text-accent-gold',
  number: 'text-primary',
  label: 'text-[#2A2104]',
  detail: 'text-[#2A2104]/70',
  Icon: AwardIcon
}, {
  card: 'bg-primary',
  icon: 'bg-white text-primary',
  number: 'text-white',
  label: 'text-white',
  detail: 'text-white/70',
  Icon: UsersIcon
}];
export function HistorySection() {
  return <section id="historia" className="bg-white py-12 md:py-14" data-id="element-292" data-mp="1kpa4rv9oz7k7">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-6 lg:grid-cols-[1.2fr_1fr] lg:gap-12" data-id="element-293" data-mp="1powfny21sbpu">
        <Reveal data-id="element-294" data-mp="2de7e38vxdu0t">
          <div className="flex items-center gap-3" data-id="element-295" data-mp="2ddp6xh7q5ve4">
            <span aria-hidden className="flex h-1.5 overflow-hidden rounded-full" data-id="element-296" data-mp="2i7jz791ebiot">
              <span className="w-6 bg-accent-gold" data-id="element-297" data-mp="3h7dh88ud6wa" />
              <span className="w-3 bg-primary" data-id="element-298" data-mp="3hz03tkgnuaf" />
              <span className="w-3 bg-secondary-maroon" data-id="element-299" data-mp="3uojsbgm95891" />
            </span>
          </div>
          <Heading level={2} size="lg" className="type-h2 mt-3" data-id="element-300" data-mp="cakd0t1ev6rc">
            Nuestra historia
          </Heading>
          <p className="mt-4 text-lg leading-relaxed text-foreground/80 md:text-xl" data-id="element-301" data-mp="7j29pybx0u37">
            Somos el Grupo Consultor Colombiano, una expresión empresarial que aporta conocimiento, experiencia y
            criterio a las decisiones que fortalecen a las empresas y contribuyen al desarrollo de la región.
          </p>
          <p className="type-lead mt-6 border-l-4 border-accent-gold pl-4 text-primary" data-id="element-302" data-mp="v8d4mz6l3u9f">
            Experiencia empresarial, criterio y <span className="text-secondary-maroon" data-id="element-303" data-mp="r56zjuv7k94j">compromiso regional</span>
          </p>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2" data-id="element-304" data-mp="2x22xci0zr6qg">
          {stats.map((stat, i) => {
          const s = statStyles[i % statStyles.length];
          return <Reveal key={stat.label} delay={0.1 + i * 0.12} className={`h-full ${i % 2 === 1 ? 'sm:pt-10' : 'sm:pb-10'}`} data-id="element-305" data-mp="vzlcfysi8l4v" data-mpi={i}>
                <motion.div whileHover={{
              y: -6
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 22
            }} className={`flex h-full flex-col justify-between rounded-[24px] p-6 md:p-7 ${s.card}`} data-id="element-306" data-mp="15veyq9w0zszu">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${s.icon}`} data-id="element-307" data-mp="1jv7jlokvfezw">
                    <s.Icon className="h-6 w-6" data-id="element-308" data-mp="1omfu6nxxt6en" />
                  </span>
                  <div className="mt-6" data-id="element-309" data-mp="1tlj0ebpnlio7">
                    <CountUp to={stat.value} className={`font-display block text-7xl font-extrabold leading-none ${s.number}`} data-id="element-310" data-mp="1tkhd98vd55q4" />
                    <p className={`mt-2 text-base font-bold uppercase tracking-wide ${s.label}`} data-id="element-311" data-mp="22nif2xd74anz">{stat.label}</p>
                    {stat.detail && <p className={`mt-1 text-base ${s.detail}`} data-id="element-312" data-mp="3n5ubclnm52k6">{stat.detail}</p>}
                  </div>
                </motion.div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}